/* KIPPOK — interactive 3D hero tilt */
(function () {
  function initHero() {
    var stage = document.getElementById('kpkStage');
    var tilt = document.getElementById('kpkTilt');
    if (!stage || !tilt) return;
    stage.addEventListener('mousemove', function (e) {
      var r = stage.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      tilt.style.animation = 'none';
      tilt.style.transform = 'rotateY(' + (x * 22) + 'deg) rotateX(' + (-y * 18) + 'deg) translateY(' + (y * 8) + 'px)';
    });
    stage.addEventListener('mouseleave', function () {
      tilt.style.transform = 'rotateY(0) rotateX(0)';
      tilt.style.animation = 'kpkFloat 6s ease-in-out infinite';
    });
  }
  /* Reveal-on-scroll for product cards */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window)) { els.forEach(function(el){el.classList.add('is-in');}); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState !== 'loading') { initHero(); initReveal(); }
  else document.addEventListener('DOMContentLoaded', function(){ initHero(); initReveal(); });
})();
